var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCorner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 115,
  height: 100,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#corner_svg__a)",
  fillOpacity: 0.4,
  d: "M73.49 42.496h-13.3c-.6 0-1.1-.4-1.1-1v-19.9C59.09 12.196 54.9 1.5 40 1.5H0v97.996h113.5V80.5c0-20.5-12.111-38.004-40.01-38.004"
})), /*#__PURE__*/React.createElement("mask", {
  id: "corner_svg__b",
  width: 67,
  height: 70,
  x: 46,
  y: 2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M50 3.5 46 2l52 11.5L113 72l-2.5-8.5-2.5-5-4-5-4-3.5-6-4-37.5-36-2-3z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#corner_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#corner_svg__c)",
  d: "M114.613 2.432H1.646v89.82h112.967z",
  opacity: 0.4
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M59.5 21c0-4.382-.609-9.03-3.5-13q.093.123.202.232c3.855 3.806 8.276 7.149 11.927 10.694 9.465 9.19 18.479 17.944 28.265 28.534q.14.151.308.272c-5.8-4.121-13.462-6.173-23.284-6.173H60.065L59.5 40.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#ECEFF1",
  d: "M40 1c15.083 0 19.325 10.31 19.325 19.894V41.07c0 .55.488.988 1.091.988h13.52C102.218 42.058 114 60.26 114 81"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "corner_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-35.841 112.924 -81.514)scale(27.742 60.9158)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.505,
  stopColor: "#212121"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A5A5A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "corner_svg__a",
  x1: 79,
  x2: 57,
  y1: 27.5,
  y2: 53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#525D62"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0BEC5",
  stopOpacity: 0
})))));
export { SvgCorner as ReactComponent };
export default "data:image/svg+xml;base64,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";